import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useWorkspaceSidebarStyles = makeStyles({
  sidebar: {
    width: projectIqTokens.sidebarWidth,
    minWidth: projectIqTokens.sidebarWidth,
    display: "flex",
    flexDirection: "column",
    backgroundColor: projectIqTokens.sidebarBg,
    borderRight: "none",
    height: "100%",
    flexShrink: 0,
    transition: `width ${designTokens.transition.base}, min-width ${designTokens.transition.base}`,
    overflow: "hidden",
  },
  sidebarCollapsed: {
    width: "68px",
    minWidth: "68px",
  },
  scrollableContent: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
  },
});
